import axiosInstance from './../axiosInstance';

/**
 * @name getOrganization
 * @desc Get single organization.
 * @param {object} credentials
 */
export const getOrganization = organizationID => {
  return axiosInstance.get('organizations/' + organizationID);
};

/**
 * @name saveOrganization
 * @desc Save single organization.
 * @param {object} credentials
 */
export const saveOrganization = (organizationID, data) => {
  return axiosInstance.post(`partners/${organizationID}`, data);
};


export const getOrganizationUsers = partnerID => {
  return axiosInstance.get(`partners/${partnerID}/users`);
}
